export const makeDirection = (address) => {
  try {
    if (!address || typeof address !== 'object') {
      throw new Error('La dirección proporcionada no es válida.');
    }

    const {
      street,
      extNumber,
      intNumber,
      postalCode,
      colony,
      municipality,
      state,
    } = address;

    if (typeof street !== 'string' || street.trim() === '') {
      throw new Error('Se requiere una calle válida.');
    }

    if (typeof extNumber !== 'string' && typeof extNumber !== 'number') {
      throw new Error('Se requiere un número exterior válido.');
    }

    const addressLabel = `${street} NoExt #${extNumber } ${intNumber ? 'NoInt # '+intNumber+', ' : ''}  ${postalCode ? ', '+postalCode : ''} ${colony ? ', '+colony : ''} ${municipality ? ', '+municipality : ''} ${state ? ', '+state : ''}`;
    
    return addressLabel;
  } catch (error) {
    console.log('Error al crear la dirección:', error.message);
    return '';
  }
}
